<template>
 <div class="card card-modal">
    <div class="row card-header">
      <div class="col-12">
        Importar lista de blacklists
      </div>
    </div>

    <div class="row card-body text-center">
      <div class="col-12">
        <div  class=" col-12 alert alert-info ">
          Cada linha do arquivo deve conter um número. <a download :href="`${host}/files/importBlacklistExemploBestuse.zip`" class="btn btn-sm btn-info">Baixar exemplo</a>
        </div>
        <label id="carregaArquivo"  for="file-upload" class="col-12 mt-2 btn btn-md btn-success">
            Escolher arquivo para importação
            <font-awesome-icon icon="file" class="pointer" />
        </label>
        <input id="file-upload" type="file" style="display: none" ref="myFile" accept="text/csv" @change="choseFile"/>
        <p class="logImport mt-4" v-show="totalLinhasArquivo > 0">
          {{ totalLinhasArquivo }} números serão importados
        </p>

        <p class="logImport mt-5" v-show="totalLinhasArquivo == 0 && read">
          Nenhum número para importação nesse arquivo
        </p>
      </div>

      <div class="col-12 ">
        <my-alert
          class="alert-success col-12 text-center"
          @done='showSuccess = false'
          :message ='successMessage'
          :show='showSuccess'
        ></my-alert>
        <my-alert
          class="alert-danger col-12 text-center"
          @done='showError = false'
          :message ='errorMessage'
          :show='showError'
          :timeout="10000"
        ></my-alert>
      </div>
    </div>

    <div class="row card-footer">
      <div class="col">
        <button class="btn col-6 btn-danger btn-md" @click="$emit('close')">
          Fechar
        </button>
        <button class="btn col-6 btn-success btn-md" @click="send()" :disabled="totalLinhasArquivo == 0 && read">
          Importar
        </button>
      </div>
    </div>
  </div>

</template>

<script>

import jwtDecode from 'jwt-decode';
import Datepicker from 'vuejs-datepicker';
import { ptBR } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import axios from 'axios';
import EventBus from './../../core/eventBus';
import SelecionaAgenda from './../agendaContato/SelecionaAgenda';
import SelecionaMensagem from './../mensagens/SelecionaMensagem';

export default {
  data() {
    return {
      fileSelected: {},
      totalLinhasArquivo: 0,
      processing: false,
      read: false,
      host: `${location.protocol}//${location.host}/`,
    }
  },
  methods: {
    choseFile(e) {
      const file = e.target.files[0];
      this.fileSelected = file;

      let formData = new FormData();
      formData.append('file', this.fileSelected);

      const app = this;

      axios.post(`${process.env.VUE_APP_API}/api/v1/v3/nao-confiavel-v3/preview`,
        formData,
        {
          headers: {
            'Authorization': this.$store.getters.authToken,
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(function(res){
        if (res.data.success) {
          app.$toasted.show('Dados contabilizados', { icon: 'check', type: 'success' });
          app.totalLinhasArquivo = res.data.total;
          app.processing = false;
        } else {
          app.$toasted.show(res.data.err, { icon: 'times', type: 'error' });
          app.processing = false;
        }
      })
      .catch(function(err){
        app.$toasted.show('Erro ao contabilizar números', { icon: 'times', type: 'error' });
        app.processing = false;
      });
    },
    async send() {
      this.processing = true;

      let formData = new FormData();
      formData.append('file', this.fileSelected);

      const app = this;

      axios.post(`${process.env.VUE_APP_API}/api/v1/v3/nao-confiavel-v3/importCsv`,
        formData,
        {
          headers: {
            'Authorization': this.$store.getters.authToken,
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(function(res){
        if (res.data.success) {
          app.$toasted.show(res.data.msg, { icon: 'check', type: 'success' });
          app.$emit('close');
        } else {
          app.$toasted.show(res.data.err, { icon: 'times', type: 'error' });
        }
      })
      .catch(function(err){
        app.$toasted.show('Erro ao importar números', { icon: 'times', type: 'error' });
      });

    }
  },

};
</script>

